<script>
  // Extensions
  import View from '@/views/View'

  // Mixins
  import LoadSections from '@/mixins/load-sections'

  export default {
    name: 'MyFaq',

    metaInfo () {
      return {
        title: this.$t('faq.title'),
        titleTemplate: (titleChunk) => {
          return titleChunk ? `${titleChunk} - ${this.$t('meta.titleTemplate')}` : this.$t('meta.titleTemplate')
        },
      }
    },

    extends: View,

    mixins: [
      LoadSections([
        'anonymous/sections/anonymous-faq',
      ]),
    ],

    props: {
      id: {
        type: String,
        default: 'faq',
      },
    },
  }
</script>
